













































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import PaginateModel from "@/model/paginate";
import CustomerEdit from "@/components/admin/customerEdit.vue";
import { UserCustomer } from "@/model/user";
import userApi from "@/api/userApi";
import CustomerUser from "@/model/customerUser";

const authStore = namespace("Auth");
@Component({
  name: "customerList",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    CustomerEdit,
  },
})
export default class CustomerList extends Vue {
  public search: any = {};
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public customers = [];

  @authStore.Getter
  public getCustomerUser!: CustomerUser;

  public headers = [
    { id: "m_cart_account.customer_code", name: "コード", order: "asc" },
    { id: "m_customers.customer_name", name: "会社名", order: "" },
    { id: "m_cart_account.account_authority", name: "権限", order: "" },
    {
      id: "m_cart_account.account_supervisor_name",
      name: "部署担当者名",
      order: "",
    },
    { id: "m_cart_account.login_id", name: "ID", order: "" },
    { id: "m_cart_account.mail_address", name: "メールアドレス", order: "" },
    { id: "", name: "" },
  ];

  async mounted() {
    this.parserQuery();
    await this.doSearch(this.search);
  }

  public parserQuery() {
    let { query } = this.$router.currentRoute;
    this.search = { ...this.search, ...query };
  }

  public edit(userCustomer: UserCustomer): void {
    // can be passing object into popup component
    (this.$refs.adminCustomerEdit as CustomerEdit).show(userCustomer);
  }

  public add(): void {
    (this.$refs.adminCustomerEdit as CustomerEdit).show();
  }

  public async doSearch(query: any) {
    this.changeState();
    this.search = { ...this.search, ...query };

    const result = await userApi.getCustomers(this.search);
    this.customers = result.list;
    this.pagination = result.paginate;
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public searchInitial() {
    return {
      code: null,
      keyword: null,
      sort: "m_cart_account.created_at",
      direction: "asc",
    };
  }

  public reload(): void {
    this.doSearch({});
  }

  public modalSave(): void {
    this.reload();
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    query = { ...query, ...this.search };

    this.$router.replace({ name: name, params, query }).catch((error) => {
      return error;
    });
  }

  public clear(): void {
    this.search = this.searchInitial();
    this.changeState();
    this.doSearch(this.search);
  }
}
